<template>
    <div>
        <div class="partner shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded" @click="handleClick">
            <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
                <partner-avatar :external-url="item.doctorAvatar" class="mr-2 w-10 h-10 md:w-12 md:h-12"></partner-avatar>
                <div class="ml-4">
                    <div class="flex items-center md:mt-1">
                        <!-- <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span> -->
                        <span class="text-sm md:text-base font-bold">{{ item.doctorFirstName + ' ' + item.doctorLastName }}</span>
                    </div>
                    <div class="flex items-center">
                        <span class="icon mr-2 text-lg text-grey"><i class="mdi mdi-map-marker"></i></span>
                        <span class="text-sm text-grey font-semi-bold">{{ item.officeZipCode }} {{ item.officeLocality }}</span>
                    </div>
                    <div class="flex mb-4">
                        <template v-if="item.isDoctorRegulated && (item.medicalPractice !== 'OSTEOPATH' && item.medicalPractice !== 'PSYCHOLOGIST')">
                            <span class="icon mr-2 text-sm text-green"><i class="mdi mdi-currency-eur"></i></span>
                            <span class="text-sm text-green">{{ $t('Contracted_doctor') }}</span>
                        </template>
                        <template v-if="!item.isDoctorRegulated && (item.medicalPractice !== 'OSTEOPATH' && item.medicalPractice !== 'PSYCHOLOGIST')">
                            <span class="icon mr-2 text-sm text-red"><i class="mdi mdi-currency-eur"></i></span>
                            <span class="text-sm text-red">{{ $t('Contracted_doctor_negative') }}</span>
                        </template>
                    </div>
                    <div class="flex items-center md:mt-1" v-for="(slot, index) in sortedSlots" :key="slot.id">
                        <span class="icon mr-2 text-lg" :class="index == 0 ? 'text-grey-darkest' : 'text-white'"><i class="mdi mdi-calendar-check"></i></span>
                        <span class="text-sm md:text-base">{{ slot.dateTime | momentFormatTimestamp($t('date_selector_format') + ' [' + $t('at') + '] ' + $t('time_format')) }}</span>
                    </div>
                    <div class="flex items-center md:mt-1" v-if="sortedSlots.length < item.timeslots.length">
                        <span class="icon mr-2 text-lg text-white"><i class="mdi mdi-calendar-check"></i></span>
                        <span class="text-sm md:text-base text-grey-dark">{{ $t('x_more_availabilities', { count: (item.timeslots.length - sortedSlots.length) }) }}</span>
                    </div>
                </div>
            </div>
            <div class="transition flex rounded-b bg-grey-light partner-hover:bg-blue text-grey-darker partner-hover:text-white py-1 justify-center">
                <span class="uppercase tracking-wide font-semibold text-sm">{{ $t('Detail_of_the_appointment') }}</span>
            </div>
        </div>
        <partner-timeslot-selection-modal
            :active="showTimeslotSelection"
            @close="hideTimeslotSelectionModal"
            :partner="item"></partner-timeslot-selection-modal>
    </div>
</template>
<script>
    import helpers from '@/mixins/helpers'

    import PartnerAvatar from '@/components/PartnerAvatar.vue'
    import PartnerTimeslotSelectionModal from '@/components/Patient/PartnerTimeslotSelectionModal.vue'

    export default {
        name: 'partner-timeslot-list-item',

        components: { PartnerAvatar, PartnerTimeslotSelectionModal },

        mixins: [helpers],

        props: ['item'],

        data () {
            return {
                showTimeslotSelection: false
            }
        },

        computed: {
            sortedSlots () {
                return _.take(_.sortBy(this.item.timeslots, ['dateTime']), 5)
            }
        },

        methods: {
            handleClick () {
                if (this.item.timeslots.length > 1) {
                    this.showTimeslotSelectionModal()
                } else {
                    this.$router.push({ name: 'partner-timeslot.show', query: {
                        doctorId: this.item.timeslots[0].doctorId,
                        dateTime: this.item.timeslots[0].dateTime,
                        medicalPractice: this.item.timeslots[0].medicalPractice,
                        latitude: this.item.timeslots[0].officeLatitude,
                        longitude: this.item.timeslots[0].officeLongitude,
                    } })
                }
            },

            showTimeslotSelectionModal () {
                this.showTimeslotSelection = true
                this.setPreventBodyScroll(true)
            },

            hideTimeslotSelectionModal () {
                this.showTimeslotSelection = false
                this.setPreventBodyScroll(false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/PartnerTimeslotListItem.vue